import ToastInstance from './Toast.vue';
import { createApp, ComponentPublicInstance } from 'vue';
import { ToastObjInstanceType } from './typings';
const div = document.createElement('div');
div.setAttribute('class', 'glb_msg');
document.body.appendChild(div);
const toastInstance = createApp(ToastInstance).mount(div);

const { ToastObj, Toast, close, types, ToastComfirm } = toastInstance as ComponentPublicInstance &
  Required<ToastObjInstanceType>;

Toast.close = close;
Toast.comfirm = ToastComfirm;

types.forEach((type) => {
  Toast[type] = (options) => {
    if (typeof options == 'string') {
      return ToastObj({
        title: options,
        type,
      });
    }
    if (typeof options == 'object') {
      return ToastObj({
        ...options,
        type,
      });
    }
  };
});

export default Toast;
